export default "__VITE_ASSET__CIc1XAi8__"